<template>
  <div class="global-action-sheet-component">
    <van-action-sheet
      v-model:show="publicStore.actionSheetConfig.isShow"
      :actions="publicStore.actionSheetConfig.options"
      :close-on-click-action="true"
      :cancel-text="$t('editProfile.Cancle')"
    />
  </div>
</template>

<script setup lang="ts">
defineOptions({ name: 'GlobalActionSheet' })

const publicStore = usePublicStore()
</script>

<style lang="scss"></style>
